import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAddDays'
})
export class DateAddDaysPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {  
    return this.addDays(value, args[0]);
  }

  private addDays(days, date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

}
